import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setError, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setAguardando(aguardando) {
    return {
        type: 'ETIQUETA_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function gerar(registro) {
    return async (dispatch, getState) => {
		
		dispatch(setAguardando(true));

	    await axios.post(`${consts.API_ETIQUETA_URL}/etiqueta`, {
			...registro,
			numero_caixa_inicio: FormatUtils.formatarValorBanco(registro.numero_caixa_inicio, 0),
			numero_caixa_fim: FormatUtils.formatarValorBanco(registro.numero_caixa_fim, 0),
			numero_caixa_total: FormatUtils.formatarValorBanco(registro.numero_caixa_total, 0)
		}).then(async resp => {

			if (resp.data && resp.data.file) {

				const file = resp.data.file;

				let qtd = 0;
				const idInterval = setInterval(async () => {

					qtd++;

					console.log(qtd * 5);

					await axios.get(`${consts.API_ETIQUETA_URL}/etiqueta?file=${encodeURI(file)}`).then(async resp => {
						
						if (resp.data && resp.data.finalizado) {

							dispatch(setAguardando(false));

							clearInterval(idInterval);

							if (window.confirm('Etiquetas geradas com sucesso')) {
								window.open(`https://api-letsaraetiquetas.infinitum-ti.com/${file}`, '_blank');
							}
						}						

					}).catch(e => {
					});

					if (qtd > 40) {

						dispatch(setAguardando(false));

						clearInterval(idInterval);

						window.alert('Não possível gerar etiquetas')
					}

				}, 5000);

			} else {
				setError('Não foi possível gerar etiquetas');	
			}
		}).catch(e => {
			dispatch(setAguardando(false));
			setErroAPI(e);
		});
    };
}
